
































import Vue from "vue";
export default Vue.extend({
    name: "DocumentToolbarMenuListItem",
    props: {
        id: String,
        text: String,
        icon: String,
        action: Function,
        enable: { default: true },
        isButton: Boolean,
        hidden: { default: false }
    }
});
